import { render, staticRenderFns } from "./FotocheckCulture.vue?vue&type=template&id=c1bce110&scoped=true"
import script from "./FotocheckCulture.vue?vue&type=script&lang=js"
export * from "./FotocheckCulture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bce110",
  null
  
)

export default component.exports